import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Кафе Шахризада", 
  description = "Восточная кухня", 
  keywords = "кафе, шаурма, восточная кухня, доставка еды, Олёкминск, олекминск, еда в Олёкминске, кафе в Олёкминске",
  ogTitle,
  ogImage,
  ogUrl,
  canonicalUrl
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl || window.location.href} />
      <meta property="og:image" content={ogImage || `${process.env.PUBLIC_URL}/images/og-default.jpg`} />
      <link rel="canonical" href={canonicalUrl || window.location.href} />
    </Helmet>
  );
};

export default SEO;